import { useDispatch, useSelector } from "react-redux";
import {
        fetchProduct,
        changeStateTrue,
        changeStateFalse,
        changeLoading,
        fetchProductFilters,
        clearProduct,
} from "../features/productSlice";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ProductCard from "../components/product/product";
import CatlogPriceFilter from "../components/priceSlider/price-slider";
import META from '../common/meta';
import {
        Container,
        Row,
        Col,
        Form,
        Breadcrumb,
        Dropdown,
} from "react-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../static/css/App.css";
library.add(fas, fab, far);
function Product() {
        const { slug } = useParams();
        const [isLoading, setIsLoading] = useState(false);
        const [priceFilter, setPriceFilter] = useState(null);
        const [productSlug, setProductSlug] = useState(null);
        const [brandFilter, setBrandFilter] = useState([]);
        const [sorting, setSorting] = useState(null);
        const [order, setOrder] = useState(null);
        const [offer, setOffer] = useState(null);
        const [isLoadingInitial, setIsLoadingInitial] = useState(false);
        const [isLoadingMore, setIsLoadingMore] = useState(false);
        const dispatch = useDispatch();
        const {
                productList,
                error,
                response,
                completed,
                breadCrumb,
                bannerImage,
                filterCategories,
                filterBrands,
                minPrice,
                maxPrice,
        } = useSelector((state) => state.product);
        const fetchData = (append = false) => {
                if (!productSlug) return;
                if (!append) {
                        setIsLoadingInitial(true);
                } else {
                        setIsLoadingMore(true);
                }
                dispatch(
                        fetchProduct({
                                categoryId: productSlug,
                                price: priceFilter,
                                brand: brandFilter.join(","),
                                order: order,
                                sort: sorting,
                                offer: offer,
                                append
                        })).finally(() => {
                                if (!append) setIsLoadingInitial(false);
                                else setIsLoadingMore(false);
                        });


        };
        const handleBrandFilter = (e) => {
                let brandId = e.target.value;
                if (brandFilter.indexOf(brandId) >= 0) {
                        setBrandFilter(brandFilter.filter((bf) => bf !== brandId));
                } else {
                        setBrandFilter([...brandFilter, brandId]);
                }
        };
        // console.log(bannerImage, 'bannerImage');
        useEffect(() => {
                setProductSlug(slug);
                dispatch(fetchProductFilters({ categoryId: slug }));
                // console.log(bannerImage, 'bannerImage');
                window.scrollTo(0, 0);
                setBrandFilter([]);
        }, [slug]);
        useEffect(() => {
                dispatch(changeLoading());
                fetchData();
                dispatch(changeStateTrue());
        }, [productSlug]);
        useEffect(() => {
                const handleScroll = () => {
                        const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
                        if (scrollTop + clientHeight >= scrollHeight - 20 && !isLoadingMore && !isLoadingInitial) {
                                fetchData(true); // append = true
                                dispatch(changeStateTrue());
                        }
                };
                window.addEventListener("scroll", handleScroll);
                return () => {
                        window.removeEventListener("scroll", handleScroll);
                };
        }, [slug, isLoadingMore, isLoadingInitial]);
        useEffect(() => {
                if (completed) {
                        setIsLoading(false);
                }
        }, [completed]);
        useEffect(() => {
                if (priceFilter) {
                        dispatch(clearProduct());
                        fetchData();
                        dispatch(changeStateTrue());
                }
        }, [priceFilter]);
        useEffect(() => {
                if (brandFilter.length > 0) {
                        dispatch(clearProduct());
                        fetchData();
                        dispatch(changeStateTrue());
                }
        }, [brandFilter]);
        const handleSortingFilter = (e) => {
                let value = e.target.value;
                setSorting("price");
                setOffer(null);
                if (value == 1) {
                        setOrder("low");
                } else if (value == 2) {
                        setOrder("high");
                } else if (value == 3) {
                        setOrder("default");
                        setOffer(1);
                } else if (value == 4) {
                        setSorting("name");
                        setOrder("asc");
                } else if (value == 5) {
                        setSorting("name");
                        setOrder("desc");
                } else {
                        setOrder("default");
                }
        };
        useEffect(() => {
                if (order) {
                        dispatch(clearProduct());
                        fetchData();
                        dispatch(changeStateTrue());
                }
        }, [order]);
        const defaultBnrImg = process.env.REACT_APP_IMAGE_URL + '/uploads/categories/df-banner.png';
        // console.log(productList,'productList');
        return (
                <div>
                        <META slug={productSlug} type="categories" />
                        <Container fluid="xl" className="px-md-5 px-3 px-xl-3">
                                <Row>
                                        {breadCrumb?.categories && (
                                                <Breadcrumb>
                                                        <Breadcrumb.Item href="#">Home</Breadcrumb.Item>

                                                        <Breadcrumb.Item
                                                                {...(breadCrumb.categories?.categories
                                                                        ? { href: breadCrumb.categories?.slug }
                                                                        : { active: true })}
                                                        >
                                                                {breadCrumb.categories?.name}
                                                        </Breadcrumb.Item>

                                                        {breadCrumb.categories?.categories && (
                                                                <Breadcrumb.Item
                                                                        {...(breadCrumb.categories?.categories?.categories
                                                                                ? { href: breadCrumb.categories?.categories?.slug }
                                                                                : { active: true })}
                                                                >
                                                                        {breadCrumb.categories?.categories?.name}
                                                                </Breadcrumb.Item>
                                                        )}

                                                        {breadCrumb.categories?.categories?.categories && (
                                                                <Breadcrumb.Item active>
                                                                        {breadCrumb.categories?.categories?.categories?.name}
                                                                </Breadcrumb.Item>
                                                        )}
                                                </Breadcrumb>
                                        )}

                                </Row>
                                <Row>
                                        <img src={bannerImage && bannerImage !== '' ? process.env.REACT_APP_IMAGE_URL + '/uploads/' + bannerImage : defaultBnrImg} alt="Category banner" />
                                </Row>
                                <Row className="my-4">
                                        <Col md="3">
                                                {breadCrumb?.categories && (
                                                        <h1 className="fs-4">
                                                                {breadCrumb.categories.categories?.categories?.name}
                                                                {breadCrumb.categories.categories &&
                                                                        !breadCrumb.categories.categories.categories && (
                                                                                <div>{breadCrumb.categories.categories.name}</div>
                                                                        )}
                                                                {breadCrumb.categories && !breadCrumb.categories.categories && (
                                                                        <div>{breadCrumb.categories.name}</div>
                                                                )}
                                                        </h1>
                                                )}
                                        </Col>
                                        <Col md="4"  >
                                                <label className="d-block text-center"  >
                                                        Price Range
                                                </label>
                                                {minPrice && maxPrice && (
                                                        <CatlogPriceFilter
                                                                min={minPrice}
                                                                max={maxPrice}
                                                                setPriceFilter={setPriceFilter}
                                                        />
                                                )}
                                        </Col>
                                        <Col md="5" className="text-sm-end text-center">
                                                <Dropdown className="d-inline mx-2" autoClose="outside">
                                                        <Dropdown.Toggle
                                                                className="product-filters text-white"
                                                                id="dropdown-autoclose-outside"
                                                        >
                                                                All Brands
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu className="filter-brand-section">
                                                                {filterBrands &&
                                                                        filterBrands.length > 0 &&
                                                                        filterBrands.map((fb, index) => (
                                                                                <Dropdown.Item as="button" key={index}>
                                                                                        <Form.Check
                                                                                                type="checkbox"
                                                                                                id={`d-checkbox-${index}`}
                                                                                                label={fb.brandName}
                                                                                                value={fb.brandID}
                                                                                                onChange={handleBrandFilter}
                                                                                        />
                                                                                </Dropdown.Item>
                                                                        ))}
                                                        </Dropdown.Menu>
                                                </Dropdown>

                                                <Dropdown className="d-inline mx-2" autoClose="true">
                                                        <Dropdown.Toggle

                                                                className="product-filters  text-white"
                                                                id="dropdown-autoclose-inside"
                                                        >
                                                                Default Sorting
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu align="end">
                                                                <Dropdown.Item as="button" key="sort-0">
                                                                        <Form.Check
                                                                                type="radio"
                                                                                id="sorting-checkbox-0"
                                                                                label="Default Sorting"
                                                                                value="0"
                                                                                name="sorting"
                                                                                onChange={handleSortingFilter}
                                                                        />
                                                                </Dropdown.Item>
                                                                <Dropdown.Item as="button" key="sort-1">
                                                                        <Form.Check
                                                                                type="radio"
                                                                                id="sorting-checkbox-1"
                                                                                label="Price Low"
                                                                                value="1"
                                                                                name="sorting"
                                                                                onChange={handleSortingFilter}
                                                                        />
                                                                </Dropdown.Item>
                                                                <Dropdown.Item as="button" key="sort-2">
                                                                        <Form.Check
                                                                                type="radio"
                                                                                id="sorting-checkbox-2"
                                                                                label="Price High"
                                                                                value="2"
                                                                                name="sorting"
                                                                                onChange={handleSortingFilter}
                                                                        />
                                                                </Dropdown.Item>
                                                                <Dropdown.Item as="button" key="sort-3">
                                                                        <Form.Check
                                                                                type="radio"
                                                                                id="sorting-checkbox-3"
                                                                                label="Offers Only"
                                                                                value="3"
                                                                                name="sorting"
                                                                                onChange={handleSortingFilter}
                                                                        />
                                                                </Dropdown.Item>
                                                                <Dropdown.Item as="button" key="sort-4">
                                                                        <Form.Check
                                                                                type="radio"
                                                                                id="sorting-checkbox-4"
                                                                                label="Name Asc"
                                                                                value="4"
                                                                                name="sorting"
                                                                                onChange={handleSortingFilter}
                                                                        />
                                                                </Dropdown.Item>
                                                                <Dropdown.Item as="button" key="sort-5">
                                                                        <Form.Check
                                                                                type="radio"
                                                                                id="sorting-checkbox-5"
                                                                                label="Name Desc"
                                                                                value="5"
                                                                                name="sorting"
                                                                                onChange={handleSortingFilter}
                                                                        />
                                                                </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                </Dropdown>
                                        </Col>
                                </Row>
                        </Container>
                        <Container fluid="xl" className="px-md-5 px-3 px-xl-3">
                                <Row className="my-5">
                                        {isLoadingInitial ? (
                                                <Col className="text-center py-5">
                                                        <div className="p-4 border rounded-4 shadow-sm bg-light d-inline-block">
                                                                <FontAwesomeIcon
                                                                        icon="fa-solid fa-spinner"
                                                                        spin
                                                                        size="3x"
                                                                        className="mb-3 text-danger"
                                                                />
                                                                <h5 className="text-muted mb-1">Loading products...</h5>
                                                        </div>
                                                </Col>
                                        ) : (
                                                <>
                                                        {productList && productList.length > 0 ? (
                                                                productList.map((product, index) =>
                                                                        product.variations.length > 0 ? (
                                                                                <ProductCard product={product} key={product.productId} index={product.productId} productKey={product.productId} />
                                                                        ) : null
                                                                )
                                                        ) : (
                                                                <Col className="text-center py-5">
                                                                        <div className="p-4 border rounded-4 shadow-sm bg-light d-inline-block">
                                                                                <FontAwesomeIcon
                                                                                        icon="fa-solid fa-box-open"
                                                                                        size="3x"
                                                                                        className="mb-3 text-secondary"
                                                                                />
                                                                                <h5 className="text-muted mb-1">Oops! No products found</h5>
                                                                                <p className="text-muted small">
                                                                                        Explore other categories.
                                                                                </p>
                                                                        </div>
                                                                </Col>
                                                        )}
                                                        {isLoadingMore && (
                                                                <Col className="text-center py-3">
                                                                        <FontAwesomeIcon
                                                                                icon="fa-solid fa-spinner"
                                                                                spin
                                                                                size="2x"
                                                                                className="text-danger"
                                                                        />
                                                                </Col>
                                                        )}
                                                </>
                                        )}
                                </Row>
                        </Container>
                </div>
        );
}

export default Product;